import { render, staticRenderFns } from "./MobileNavigationButton.vue?vue&type=template&id=2219a596&scoped=true&"
import script from "./MobileNavigationButton.vue?vue&type=script&lang=ts&"
export * from "./MobileNavigationButton.vue?vue&type=script&lang=ts&"
import style0 from "./MobileNavigationButton.vue?vue&type=style&index=0&id=2219a596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2219a596",
  null
  
)

export default component.exports